import '@angular/compiler';
import { PortalAnalysisWidgetStabilityComponent } from './portal.analysis.widget.stability/portal.analysis.widget.stability.component';
import { PortalOverviewWidgetAvgOutputsComponent } from './portal.overview.widget.avg.outputs/portal.overview.widget.avg.outputs.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { LayoutDefaultComponent } from './layout.default/layout.default.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { ComponentUndefindComponent } from './component.undefind/component.undefind.component';
import { ComponentNavComponent } from './component.nav/component.nav.component';
import { ComponentTooltipComponent } from './component.tooltip/component.tooltip.component';
import { PortalNetworkWidgetDetailComponent } from './portal.network.widget.detail/portal.network.widget.detail.component';
import { PortalOverviewDashboardComponent } from './portal.overview.dashboard/portal.overview.dashboard.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { PortalAchievementsListComponent } from './portal.achievements.list/portal.achievements.list.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { PortalAnalysisWidgetScalabilityComponent } from './portal.analysis.widget.scalability/portal.analysis.widget.scalability.component';
import { PortalOverviewWidgetComponent } from './portal.overview.widget/portal.overview.widget.component';
import { PortalAnalysisWidgetCategoryComponent } from './portal.analysis.widget.category/portal.analysis.widget.category.component';
import { PageDetailComponent } from './page.detail/page.detail.component';
import { PortalOverviewWidgetWordcloudComponent } from './portal.overview.widget.wordcloud/portal.overview.widget.wordcloud.component';
import { PortalAnalysisWidgetSearchComponent } from './portal.analysis.widget.search/portal.analysis.widget.search.component';
import { PortalOverviewWidgetTop5Component } from './portal.overview.widget.top5/portal.overview.widget.top5.component';
import { PortalOverviewWidgetChartComponent } from './portal.overview.widget.chart/portal.overview.widget.chart.component';
import { PortalNetworkWidgetGraphComponent } from './portal.network.widget.graph/portal.network.widget.graph.component';
import { PortalAnalysisWidgetExpertiseComponent } from './portal.analysis.widget.expertise/portal.analysis.widget.expertise.component';
import { LayoutMainComponent } from './layout.main/layout.main.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { PortalOverviewWidgetOutputsComponent } from './portal.overview.widget.outputs/portal.overview.widget.outputs.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PortalNetworkDashboardComponent } from './portal.network.dashboard/portal.network.dashboard.component';
import { ComponentSearchComponent } from './component.search/component.search.component';
import { PageListComponent } from './page.list/page.list.component';
import { PortalOverviewWidgetStabilityComponent } from './portal.overview.widget.stability/portal.overview.widget.stability.component';
import { ComponentFooterComponent } from './component.footer/component.footer.component';
import { PageMainComponent } from './page.main/page.main.component';
import { PortalAnalysisDashboardComponent } from './portal.analysis.dashboard/portal.analysis.dashboard.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [
        AppComponent,
        PortalAnalysisWidgetStabilityComponent,
        PortalOverviewWidgetAvgOutputsComponent,
        PortalSeasonTabComponent,
        LayoutDefaultComponent,
        PortalSeasonUiDropdownComponent,
        ComponentUndefindComponent,
        ComponentNavComponent,
        ComponentTooltipComponent,
        PortalNetworkWidgetDetailComponent,
        PortalOverviewDashboardComponent,
        PortalSeasonAlertComponent,
        PortalAchievementsListComponent,
        PortalSeasonPagenationComponent,
        PortalAnalysisWidgetScalabilityComponent,
        PortalOverviewWidgetComponent,
        PortalAnalysisWidgetCategoryComponent,
        PageDetailComponent,
        PortalOverviewWidgetWordcloudComponent,
        PortalAnalysisWidgetSearchComponent,
        PortalOverviewWidgetTop5Component,
        PortalOverviewWidgetChartComponent,
        PortalNetworkWidgetGraphComponent,
        PortalAnalysisWidgetExpertiseComponent,
        LayoutMainComponent,
        PortalSeasonViewerTreeComponent,
        PortalSeasonLoadingSeasonComponent,
        PortalSeasonLoadingComponent,
        PortalOverviewWidgetOutputsComponent,
        PortalSeasonStatusbarComponent,
        PortalSeasonLoadingHexaComponent,
        PortalNetworkDashboardComponent,
        ComponentSearchComponent,
        PageListComponent,
        PortalOverviewWidgetStabilityComponent,
        ComponentFooterComponent,
        PageMainComponent,
        PortalAnalysisDashboardComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }